module.exports = __webpack_public_path__ + "img/193.83a5da05.jpg";